<template>
  <v-btn @click="authorize" :disabled="!clientReady" v-bind="$attrs">
    Authorize with Google
  </v-btn>
</template>

<script>
/* global google */
export default {
  name: "GoogleAuthorizeButton",
  data() {
    return {
      client: null,
      clientReady: false, // To track if the client is ready
    };
  },
  props: {
    clientId: {
      type: String,
      required: true,
    },
    scopes: {
      type: String,
      required: true,
    },
    codeReceiverUri: {
      type: String,
      required: true,
    },
  },
  methods: {
    authorize() {
      this.client.requestCode();
    },
    callback(response) {
      if (response && response.code) {
        console.log("Authorization code: " + response.code);
        console.log("Authorization scope: " + response.scope);
        let scopeList = response.scope.split(" ");

        this.$emit("on-authorized", {
          authorizationCode: response.code,
          scopes: scopeList,
        });
      }
    },
  },
  mounted() {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.client = google.accounts.oauth2.initCodeClient({
        client_id: this.clientId,
        scope: this.scopes,
        ux_mode: "popup",
        callback: this.callback,
      });
      this.clientReady = true; // Mark the client as ready
    };
    document.body.appendChild(script);
  },
};
</script>
